<script setup lang="ts">
import { computed } from "vue";
import Icon from "./Icon.vue";
import Field from "./Field.vue";

const props = withDefaults(
  defineProps<{
    modelValue?: string | number;
    label?: string;
    hint?: string;
    error?: string;
    icon?: string;
    suffix?: string;
    size?: "md" | "lg";
    type?: string;
    inputmode?: "text" | "numeric" | "decimal";
    placeholder?: string;
    disabled?: boolean;
    id?: string;
  }>(),
  { size: "md", type: "text" },
);
const emit = defineEmits<{ "update:modelValue": [string | number] }>();

const shell = computed(() => [
  "cw-input",
  props.size === "lg" ? "cw-input--lg" : "",
  props.error ? "cw-input--error" : "",
  props.disabled ? "cw-input--disabled" : "",
]);
const wrapped = computed(() => Boolean(props.label ?? props.hint ?? props.error));

function onInput(event: Event) {
  const el = event.target as HTMLInputElement;
  // Numeric fields must not emit "" as 0 -- the caller decides what empty means.
  emit("update:modelValue", props.inputmode === "numeric" ? Number(el.value) : el.value);
}
</script>
<template>
  <component
    :is="wrapped ? Field : 'div'"
    v-bind="wrapped ? { label, hint, error, htmlFor: id } : { style: 'display:contents' }"
  >
    <div :class="shell">
      <Icon
        v-if="icon"
        :name="icon"
        :size="17"
        color="var(--text-muted)"
      />
      <input
        :id="id"
        class="cw-input__el"
        :type="type"
        :inputmode="inputmode"
        :placeholder="placeholder"
        :disabled="disabled"
        :value="modelValue"
        @input="onInput"
      >
      <span
        v-if="suffix"
        class="cw-input__affix"
      >{{ suffix }}</span>
    </div>
  </component>
</template>
